var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-navbar', {
    staticClass: "navbar default-layout col-12 p-0 fixed-top d-flex flex-row",
    attrs: {
      "id": "template-header",
      "toggleable": "md"
    }
  }, [_c('div', {
    staticClass: "\n        text-center\n        navbar-brand-wrapper\n        d-flex\n        align-items-center\n        justify-content-center\n        flex-grow-1 flex-xl-grow-0\n      "
  }, [_vm.isMobile ? _c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-backdrop",
      modifiers: {
        "sidebar-backdrop": true
      }
    }],
    staticClass: "d-flex align-items-center ml-2 mr-4"
  }, [_c('BIconList', {
    staticClass: "h4 mb-0"
  })], 1) : _c('div', {
    staticClass: "d-flex align-items-center mr-2",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setMainViewExpand(!_vm.mainViewExpand);
      }
    }
  }, [_c('BIconList', {
    staticClass: "h4 mb-0"
  })], 1), _c('router-link', {
    staticClass: "navbar-brand brand-logo",
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('h5', {
    staticClass: "font-bold m-0",
    staticStyle: {
      "line-height": "63px"
    }
  }, [_vm._v(" " + _vm._s(this.organization.name) + " ")])]), _c('router-link', {
    staticClass: "navbar-brand brand-logo-mini ",
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('h5', {
    staticClass: "font-bold m-0",
    staticStyle: {
      "line-height": "63px"
    }
  }, [_vm._v(" " + _vm._s(this.organization.name) + " ")])])], 1), _c('div', {
    staticClass: "navbar-menu-wrapper d-flex align-items-center ml-lg-0 flex-grow-1"
  }, [_c('b-navbar-nav', {
    staticClass: "navbar-nav-left ml-auto"
  }, [_c('form', {
    staticClass: "mr-auto search-form d-none d-md-block",
    attrs: {
      "action": "#"
    }
  }), _c('li', {
    staticClass: "nav-item"
  }, [_vm.showLogoutTimer ? _c('div', {
    staticClass: "nav-link text-nowrap mr-4"
  }, [_vm._v(_vm._s(_vm.remainSeconds) + " 秒後登出")]) : _vm._e()]), _vm.$permissions.has(_vm.$permissions.consts.MY_NOTIFICATION) ? _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('router-link', {
    staticClass: "nav-link count-indicator",
    attrs: {
      "to": {
        name: 'BranchNotificationList'
      }
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('i', {
    staticClass: "mdi mdi-bell-outline"
  }), _vm.unreadNotificationCount > 0 ? _c('sup', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.unreadNotificationCount))])], 1) : _vm._e()])])], 1) : _vm._e(), _c('b-nav-item-dropdown', {
    staticClass: "preview-list user-dropdown",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('b-avatar', {
    attrs: {
      "src": _vm.staff.avatar_url,
      "size": "2rem"
    }
  })], 1), _c('b-dropdown-item', [_c('div', {
    staticClass: "dropdown-header text-center w-100 mx-0 px-0"
  }, [_c('b-avatar', {
    attrs: {
      "src": _vm.staff.avatar_url,
      "size": "4rem"
    }
  }), _vm.staff.name ? _c('p', {
    staticClass: "mb-1 mt-3 font-weight-semibold max-w-full overflow-hidden"
  }, [_vm._v(" " + _vm._s(_vm.staff.name) + " ")]) : _vm._e(), _vm.staff.employee_code ? _c('p', {
    staticClass: "font-weight-light text-muted mb-0 max-w-full overflow-hidden"
  }, [_vm._v(" " + _vm._s(_vm.staff.employee_code) + " ")]) : _vm._e(), _vm.staff.email ? _c('p', {
    staticClass: "font-weight-light text-muted mb-0 max-w-full overflow-hidden"
  }, [_vm._v(" " + _vm._s(_vm.staff.email) + " ")]) : _vm._e(), _vm.staff.role_name ? _c('p', {
    staticClass: "font-weight-light text-muted mb-0 max-w-full overflow-hidden"
  }, [_vm._v(" " + _vm._s("\u8EAB\u4EFD\uFF1A".concat(_vm.staff.role_name)) + " ")]) : _vm._e()], 1)]), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_vm._v(" 基本資料 "), _c('i', {
    staticClass: "fa fa-user-circle"
  })]), _vm.$permissions.has(_vm.$permissions.consts.MY_STAFF_PROFILE) ? _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'ExtendedProfile'
      }
    }
  }, [_vm._v(" 個人化設定 "), _c('i', {
    staticClass: "fa fa-gear"
  })]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.MY_BOOKING_SHIFT) ? _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'BookingShiftList'
      }
    }
  }, [_vm._v(" 預約班表設定 "), _c('i', {
    staticClass: "mdi mdi-calendar-clock"
  })]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.MY_CHANGE_PASSWORD) ? _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'StaffChangePassword',
        params: {
          staff_id: this.staff.id
        },
        query: {
          profile: 1
        }
      }
    }
  }, [_vm._v(" 變更密碼 "), _c('i', {
    staticClass: "fa fa-key"
  })]) : _vm._e(), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" 登出 "), _c('i', {
    staticClass: "fa fa-sign-out"
  })])], 2)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }